import React from "react";

import {CartProvider} from "@contexts/Cart.jsx"
import {ProductCustomizerVariantProvider} from "@contexts/ProductCustomizerVariant.jsx"

import ProductCustomizerNote from "@components/customizer/ProductCustomizerNote.jsx"
import CloseIcon from "@assets/Close.svg";
import ProductCustomizerVariant from "@components/customizer/ProductCustomizerVariant.jsx"
import ProductCustomizerFooter from "@components/customizer/ProductCustomizerFooter.jsx";
import ProductCustomizerTray from "@components/customizer/ProductCustomizerTray.jsx";

import "@styles/react-components/customizer.scss";

export default ({productHandle, variantId, drawerElement}) => {

  return <ProductCustomizerVariantProvider productHandle={productHandle} variantId={variantId} drawerElement={drawerElement}>
            <CartProvider>
              <ProductCustomizerNote>
                <div>
                  <div className="cart-drawer__top">
                    <div className="h-stack items-center justify-between">
                      <div className="h-stack gap-2 sm:gap-2.5">
                        <p className="h4">{window.themeVariables?.strings?.cartAdded || 'Added to Cart'}</p>
                      </div>
                      <button type="button" is="close-button" class="drawer__close-icon">
                        <span className="sr-only">{window.themeVariables?.string?.accessibilityClose || 'Close'}</span>
                        <CloseIcon />
                      </button>
                    </div>
                  </div>
                  <ProductCustomizerVariant />
                </div>
                <ProductCustomizerTray />
                <ProductCustomizerFooter />
              </ProductCustomizerNote>
            </CartProvider>
          </ProductCustomizerVariantProvider>
}
